import '../media/css/AppTopHeader.css';
import React from 'react';
import { Button } from 'reactstrap';

class AppTopHeader extends React.Component {
	render() {
		let msg, logout="";
		if ( typeof this.props.loggedIn === 'undefined' ) {
			msg = "";
		} else if ( this.props.loggedIn ) {
			const la = ()=>{ window.glob.logout() };
			const ld = window.glob.getStatus('login');
			msg =  <b>{ld.name}</b>;
			logout = (
				<Button color={"danger"} onClick={la} className={"btn-icon"}>
					<i>⎋</i>
					<b>Logout</b>
				</Button>
			);
		} else {
			msg = <small>Accesso non effettuato</small>;
		}
		return (
			<header className="AppTopHeader">
				<div className={"AppTopHeaderLeft"}>
					<div className={"AppTopHeaderLogo"}>
						<img src="media/logo-uniroma3.png" alt="UniRoma3" />
					</div>
					<h1>
						Prenotazioni { msg }
					</h1>
				</div>
				<div className={"AppTopHeaderRight mobile-only"}>
					{ logout }
				</div>
			</header>
		);
	};
}

export default AppTopHeader;